export default __webpack_public_path__ + "static/media/promocionAlarma2.b123fd37.png";